import { t } from '@/i18n/i18n';

/** Ошибка HTTP-слоя: статус, код бэкенда (`error`) и тело ответа (TRK-1). */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string | undefined;
  readonly data: unknown;

  constructor(message: string, status: number, code?: string, data?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.data = data;
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}

/** Человекочитаемый текст для 429 — единственный статус, который показываем как есть. */
export function rateLimitMessage(): string {
  return t('errors.rateLimit');
}

/** Текст ошибки для интерфейса: сеть, лимит или сообщение бэкенда. */
export function humanizeError(error: unknown, fallback = t('errors.generic')): string {
  if (isApiError(error)) {
    if (error.status === 429) return rateLimitMessage();
    if (error.status === 0) return t('errors.network');
    return error.message || fallback;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
